import React from 'react';
import PropTypes from 'prop-types';

import Card from './Card'
import {CardWrapper, HeadingStyle} from './styled';

const TeamCard = ({data, leadership}) => {

    return (
      <React.Fragment>
        <HeadingStyle
          leaderStyle={leadership && true}
          fontSize={['30px']}
          fontWeight={[400]}
          color={'white'}
        >
          {data.primary.title.text && data.primary.title.text}
        </HeadingStyle>
        <CardWrapper leaderStyle={leadership && true}>
          {data.items.map(el => (
            (<Card 
              name={el.employee_name}
              job={el.employee_job_title}
              image={el.employee_image}
              leaderStyle={leadership && true}
             />)
          ))}
        </CardWrapper>
      </React.Fragment> 
    );
};

TeamCard.propTypes = {
  data: PropTypes.object,
  leadership: PropTypes.bool
}

export default TeamCard;